import { render, staticRenderFns } from "./HistoricalReport.vue?vue&type=template&id=c29bbb76&scoped=true&"
import script from "./HistoricalReport.vue?vue&type=script&lang=js&"
export * from "./HistoricalReport.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalReport.vue?vue&type=style&index=0&id=c29bbb76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29bbb76",
  null
  
)

export default component.exports